import React, { useEffect, useState } from 'react';
import { Typography } from 'fronton-react';
import { BestPriceIcon } from 'common/icons/best-price-icon';
import { useTranslation } from 'react-i18next';
import { bestPriceNameplateStickyContainer } from './sticky.styles';
import { bestPriceNameplateContainer, textStyle } from './styles';

type ProductBestPriceNameplateProps = {
  isSticky?: boolean;
};

export const ProductBestPriceNameplate: React.FC<ProductBestPriceNameplateProps> = ({ isSticky }) => {
  const { t } = useTranslation();
  const [stickyClass, setStickyClass] = useState(bestPriceNameplateContainer);
  useEffect(() => {
    if (isSticky) {
      setStickyClass(bestPriceNameplateStickyContainer);
    } else {
      setStickyClass(bestPriceNameplateContainer);
    }
  }, [isSticky]);
  return (
    <div
      className={stickyClass}
      data-qa={isSticky ? 'stickyProductBestPriceNameplate' : 'productBestPriceNameplate'}
    >
      <BestPriceIcon />
      <Typography variant="caption_accent" color="text-primary" className={textStyle}>
        {t('price.best-price')}!
      </Typography>
    </div>
  );
};
